import {Card} from './Card'

export class Deck
{
    name: string = "Default Name";
    cards: Card[] = [];
}


// WEBPACK FOOTER //
// ./src/deckard/models/Deck.ts